<template>
  <div>
    <el-select v-model="queryParam.type" placeholder="请选择日志类型" style="width: 200px;">
      <el-option label="操作日志" value="1"></el-option>
      <el-option label="系统日志" value="2"></el-option>
    </el-select>&nbsp;&nbsp;
    <el-select v-model="queryParam.oper" placeholder="请选择操作类型" style="width: 200px;">
      <el-option label="状态变更" value="1"></el-option>
      <el-option label="用户备注修改" value="2"></el-option>
      <el-option label="内部备注修改" value="3"></el-option>
      <el-option label="订单修改" value="4"></el-option>
      <el-option label="订单配送" value="5"></el-option>
      <el-option label="订单退款" value="6"></el-option>
    </el-select>&nbsp;&nbsp;
    <el-input v-model="queryParam.operName" placeholder="操作人" style="width: 200px;" clearable />&nbsp;&nbsp;
    <el-button type="primary" plain @click="handleQueryList">查询</el-button>&nbsp;&nbsp;
    <el-button @click="handleReset">重置</el-button>
    <el-table row-key="sid" :data="tableData">
      <el-table-column type="selection" align="center" :reserve-selection="true" width="55"></el-table-column>
      <el-table-column prop="bplatType" key="bplatType" label="订单渠道">
        <template slot-scope="scope">
          <span v-if="scope.row.bplatType === 1">美团</span>
          <span v-else-if="scope.row.bplatType === 2">饿了么</span>
          <span v-else-if="scope.row.bplatType === 3">京东到家</span>
          <span v-else-if="scope.row.bplatType === 4">小程序订单</span>
          <span v-else-if="scope.row.bplatType === 6">TOPS订单</span>
        </template>
      </el-table-column>
      <el-table-column prop="corderNo" key="corderNo" label="订单号" width="160"/>
      <el-table-column prop="btype" key="btype" label="日志类型">
        <template slot-scope="scope">
          <span v-if="scope.row.btype === 1">操作日志</span>
          <span v-else-if="scope.row.btype === 2">系统日志</span>
        </template>
      </el-table-column>
      <el-table-column prop="boper" key="boper" label="日志类型">
        <template slot-scope="scope">
          <span v-if="scope.row.boper === 1">状态变更</span>
          <span v-else-if="scope.row.boper === 2">用户备注修改</span>
          <span v-else-if="scope.row.boper === 3">内部备注修改</span>
        </template>
      </el-table-column>
      <el-table-column prop="soper" key="soper" label="操作人" width="160"/>
      <el-table-column prop="soperTime" key="soperTime" label="操作时间" width="160"/>
      <el-table-column prop="soperOld" key="sOperOld" label="原值" width="160" show-overflow-tooltip/>
      <el-table-column prop="soperNew" key="soperNew" label="新值" width="160" show-overflow-tooltip/>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "logOrderDialog",
  props: {
    orderNo: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      queryParam: {},
      tableData: [],
    };
  },
  mounted() {
    this.handleQueryList();
  },
  methods: {
    handleQueryList() {
      this.topsAjax.get(`${this.baseUrls.logOrder}/queryList`, { ...this.queryParam, orderNo: this.orderNo }).then((response) => {
        this.tableData = response;
      });
    },
    handleReset() {
      this.queryParam = {}
      this.handleQueryList()
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
